module.exports = __webpack_public_path__ + "img/JT_icons01_64px_LogOut.8fe16e42.svg";